<template>
  <generic-modal :modal-key="'unsubscribe'" :has-extra-modal-class="'popup_box op_down modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ userDetails.username }}, {{ getTranslations.home_modals_unsubscribe_choice_in_level }}</h1>
      <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">
      <p>{{ getTranslations.home_modals_unsubscribe_choice_if_you }}</p>
      <div class="modal_middle_title">
        <h1>{{ getTranslations.home_modals_unsubscribe_continue }}</h1>
      </div>
      <div class="modal__footer">
        <div class="modal_two_btns">
          <a @click="unsubscribe" style="cursor:pointer" class="ti_btn--main">
            {{ getTranslations.home_modals_unsubscribe_choice_unsubscribe }}
          </a>
        </div>
        <div class="modal_two_btns">
          <a class="ti_btn--second" @click="noUnSubscribe" style="cursor:pointer">
            {{ getTranslations.home_modals_unsubscribe_choice_cancel }}
          </a>
        </div>
      </div>
    </template>
  </generic-modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../../common/modals';
import Resubscribe from './Resubscribe';
import ResubscribeGameSms from './ResubscribeGameSms';
import UnsubscribeSms from './UnsubscribeSms';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  // modal_unsubscribe.html
  name: 'unsubscribe',
  mixins: [IntegrationMixin],
  components: {
    GenericModal,
    Resubscribe,
    ResubscribeGameSms,
    UnsubscribeSms,
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'storeModalForSettings',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapActions('common', [
      'optoutCall',
    ]),
    noUnSubscribe() {
      modals.hideModal(this);
    },
    unsubscribe() {
      this.optoutCall().then(() => {
        this.getUserLoginDetails().then(() => {
          if (this.userDetails.subscribed) {
            modals.hideModal(this);
          } else {
            if (this.subAndUnsubViaSMS && (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS')) {
              this.storeModalForHomePage(ResubscribeGameSms);
            } else {
              this.storeModalForHomePage(Resubscribe);
            }
            modals.showHideModal(this);
          }
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>

<style type="text/css">
  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/modals/Unsubscribe.vue